import(/* webpackMode: "eager", webpackExports: ["PageClientComponent"] */ "/app/src/app/[locale]/stores/[city]/[address]/components/page-client-component/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicYieldProvider"] */ "/app/src/context/dynamic-yield/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VariablesProvider"] */ "/app/src/context/variables/provider.tsx");
